import { Component, OnInit, Inject } from '@angular/core';
import { AlertService } from 'src/app/services/alert.service';
import { DbdataService } from 'src/app/services/dbdata.service';
import { AauthService } from 'src/app/services/aauth.service';
import { DOCUMENT } from '@angular/common';
import { FormBuilder, Validators } from '@angular/forms';
import { ProfileService } from '../profile.service';
import { RegisterService } from '../../register/register.service';
import { Utilities } from 'src/app/services/utilities';

declare function InitMyJs(): void; // fake to skip ide error.

@Component({
  selector: 'app-profile1',
  templateUrl: './profile1.component.html',
  styleUrls: ['./profile1.component.scss']
})
export class Profile1Component implements OnInit {

  constructor(
    private fb: FormBuilder,
    private alertService: AlertService,
    private dbDataService: DbdataService,
    public profileService: ProfileService,
    private authService: AauthService,
    public registerService: RegisterService,
    @Inject(DOCUMENT) private document: Document){ }

  isFlyout = this.registerService._isFlyout;
    dbIndustries = null;
    dbSpecialties = null;
    dbSubSpecialties = null;
    years = [];
    months = [
      { id: 1, name: 'January' },
      { id: 2, name: 'February' },
      { id: 3, name: 'March' },
      { id: 4, name: 'April' },
      { id: 5, name: 'May' },
      { id: 6, name: 'June' },
      { id: 7, name: 'July' },
      { id: 8, name: 'August' },
      { id: 9, name: 'September' },
      { id: 10, name: 'October' },
      { id: 11, name: 'November' },
      { id: 12, name: 'December' }
    ];

    frmProfile = this.fb.group({
      IndustryId: [null, [Validators.required]],
      SpecialtyId: [null, [Validators.required]],
      SubSpecialtyId: [null],
      MonthStarted: [null, [Validators.required]],
      YearStarted: [null, [Validators.required]],
    });

    ngOnInit(): void {
      try {
        InitMyJs();
      } catch (error) {
        console.error(error);
      }

      this.loadYears();
      this.getIndustries();
      this.loadProfessionalBusinessAreas();
    }

    get f() {
      return this.frmProfile.controls;
    }

    loadProfessionalBusinessAreas() {
      this.dbDataService.getProfessionalBusinessAreas().subscribe(
        (data: any) => {
          if (data.professionalAreas != null) {
            this.f.IndustryId.setValue(0); //data.professionalAreas.industryId
          }
          console.log(data);
        },
        error => console.error(error)
      );
    }

    getIndustries() {
      this.dbDataService.getIndustries()
      .subscribe({
        next: data => {
          this.dbIndustries = data;
        }
        , error: error =>  console.log(error)
      });
    }

    onIndustryChange(event) {
      const id = event.target.value;
      this.dbDataService.getSpecialties(id)
      .subscribe({
        next: data => { this.dbSpecialties = data; }
        , error: error =>  console.error(error)
      });
    }

    onSpecialtiesChange(event) {
      const id = event.target.value;
      this.dbDataService.getSubSpecialties(id)
      .subscribe({
        next: data => { this.dbSubSpecialties = data; }
        , error: error =>  console.error(error)
      });
    }

    OnFinishStep() {
      if (this.profileService.isLoading) { return; }

      if (!this.frmProfile.valid) {
        Utilities.validateAllFormFields(this.frmProfile);
        return;
      }
      this.profileService.isLoading = true;
      this.alertService.startLoadingMessage();
      this.dbDataService.addProfessional(
        this.frmProfile.get('IndustryId').value,
        this.frmProfile.get('SpecialtyId').value || 0,
        this.frmProfile.get('SubSpecialtyId').value || 0,
        this.frmProfile.get('MonthStarted').value,
        this.frmProfile.get('YearStarted').value
      ).subscribe ({
        next: (data: any) => {
          this.alertService.stopLoadingMessage();
          this.profileService.isLoading = false;
          this.profileService.submitedStep[0] = true;
          if (this.isFlyout) {
            $("#btnCallback").click(); //force the click - hack to pass an event from ang 9 back to script file in non-angular
          }
          else {
            this.authService.locationTo('/Professional/Edit');
          }
        },
        error: error => {
          this.alertService.stopLoadingMessage();
          this.profileService.isLoading = false;
          this.alertService.showError(error);
        }
      });
    }

    OnSkipStep() {
      if (this.isFlyout) {
        $("#btnCallback").click(); //force the click - hack to pass an event from ang 9 back to script file in non-angular
      }
      else {
        this.document.location.href = '/';
      }
    }

    /**
     *
     * Get years fucntion
     */

    getYears(offset, range) {
      const currentYear = new Date().getFullYear();
      let val = 0;
      const years = [];
      for (let i = 0; i > range + 1; i--) {
          val = currentYear + offset + i;
          years.push(val);
      }
      return years;
    }

    /**
     *
     * Get load years fucntion
     */
    loadYears() {
      this.years = this.getYears(0, -70);
    }
}
